import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "me-1 ms-auto" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge badge-pill badge-gray" }, " New ")
], -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.cdc.gov/coronavirus/2019-ncov/index.html",
  rel: "noopener noreferrer",
  target: "_blank"
}, " COVID-19: CDC Coding Guidance ", -1 /* HOISTED */)
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = { class: "table table-responsive-md border border-gray overflow-auto" }
const _hoisted_6 = { class: "bg-table-header" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", null, "ICD-10 Code", -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", null, "Description", -1 /* HOISTED */)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", null, "Start Date", -1 /* HOISTED */)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Actions", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableEmpty = _resolveComponent("TableEmpty")!
  const _component_DiagnosisTableRow = _resolveComponent("DiagnosisTableRow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.snapshotView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("button", {
            class: "btn btn-primary btn-xs ms-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addDiagnosis()))
          }, "Add Diagnosis")
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            (!_ctx.isApplicationPalliative)
              ? (_openBlock(), _createElementBlock("th", _hoisted_9, "Related"))
              : _createCommentVNode("v-if", true),
            _hoisted_10,
            (_ctx.snapshotView)
              ? (_openBlock(), _createElementBlock("th", _hoisted_11, "Resolved Date"))
              : _createCommentVNode("v-if", true),
            _hoisted_12
          ])
        ]),
        _createCommentVNode("Empty Table"),
        (_ctx.diagnosis.length == 0 && _ctx.newDiagnosis.length == 0)
          ? (_openBlock(), _createBlock(_component_TableEmpty, {
              key: 0,
              "col-span": _ctx.columns,
              component: "diagnoses",
              "secondary-message": "No Diagnoses Found"
            }, null, 8 /* PROPS */, ["col-span"]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode("Existing Diagnoses"),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeDiagnosis, (diag, index) => {
          return (_openBlock(), _createBlock(_component_DiagnosisTableRow, {
            index: index,
            key: diag.id,
            diag: diag,
            "move-diagnosis-up": _ctx.moveDiagnosis,
            "make-primary": _ctx.makePrimary,
            "move-diagnosis-down": _ctx.moveDiagnosis,
            "resolve-diagnosis": _ctx.resolveDiagnosis,
            first: index === 0,
            last: index === _ctx.activeDiagnosis.length - 1,
            id: _ctx.id,
            "show-diagnosis-message": _ctx.showDiagnosisMessage,
            "snapshot-view": _ctx.snapshotView,
            "delete-diagnosis": _ctx.deleteDiagnosis,
            referral: _ctx.referral,
            "is-palliative": _ctx.isApplicationPalliative
          }, null, 8 /* PROPS */, ["index", "diag", "move-diagnosis-up", "make-primary", "move-diagnosis-down", "resolve-diagnosis", "first", "last", "id", "show-diagnosis-message", "snapshot-view", "delete-diagnosis", "referral", "is-palliative"]))
        }), 128 /* KEYED_FRAGMENT */)),
        _createCommentVNode("New Diagnoses"),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newDiagnosis, (diag, index) => {
          return _withDirectives((_openBlock(), _createBlock(_component_DiagnosisTableRow, {
            index: index,
            key: diag.id,
            diag: diag,
            updateDiag: _ctx.updateDiag,
            "is-add-requested": _ctx.isAddRequested,
            "onUpdate:is-add-requested": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isAddRequested) = $event)),
            "save-new-diagnosis": _ctx.saveNewDiagnosis,
            "cancel-save-new-diagnosis": _ctx.cancelSaveNewDiagnosis,
            "is-new-terminal": _ctx.isNewTerminal,
            "snapshot-view": _ctx.snapshotView,
            referral: _ctx.referral,
            "is-palliative": _ctx.isApplicationPalliative
          }, null, 8 /* PROPS */, ["index", "diag", "updateDiag", "is-add-requested", "save-new-diagnosis", "cancel-save-new-diagnosis", "is-new-terminal", "snapshot-view", "referral", "is-palliative"])), [
            [_vShow, _ctx.newDiagnosis.length > 0]
          ])
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}